import { render, staticRenderFns } from "./NoticeNewArrivalsModalSection.vue?vue&type=template&id=6bcf0fb4&scoped=true"
import script from "./NoticeNewArrivalsModalSection.vue?vue&type=script&lang=ts"
export * from "./NoticeNewArrivalsModalSection.vue?vue&type=script&lang=ts"
import style0 from "./NoticeNewArrivalsModalSection.vue?vue&type=style&index=0&id=6bcf0fb4&prod&scoped=true&lang=scss"
import style1 from "./NoticeNewArrivalsModalSection.vue?vue&type=style&index=1&id=6bcf0fb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf0fb4",
  null
  
)

export default component.exports